
// @ts-nocheck
import locale_en_46json_e2607e1d from "#nuxt-i18n/e2607e1d";
import locale_de_46json_003ea729 from "#nuxt-i18n/003ea729";
import locale_fr_46json_04510cf7 from "#nuxt-i18n/04510cf7";
import locale_ru_46json_5f97cf9f from "#nuxt-i18n/5f97cf9f";
import locale_zh_CN_46json_0a9e96a3 from "#nuxt-i18n/0a9e96a3";
import locale_zh_TW_46json_a86b7ad4 from "#nuxt-i18n/a86b7ad4";

export const localeCodes =  [
  "en",
  "de",
  "fr",
  "ru",
  "zh-CN",
  "zh_TW"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_e2607e1d",
      load: () => Promise.resolve(locale_en_46json_e2607e1d),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_003ea729",
      load: () => Promise.resolve(locale_de_46json_003ea729),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_04510cf7",
      load: () => Promise.resolve(locale_fr_46json_04510cf7),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_5f97cf9f",
      load: () => Promise.resolve(locale_ru_46json_5f97cf9f),
      cache: true
    }
  ],
  "zh-CN": [
    {
      key: "locale_zh_CN_46json_0a9e96a3",
      load: () => Promise.resolve(locale_zh_CN_46json_0a9e96a3),
      cache: true
    }
  ],
  zh_TW: [
    {
      key: "locale_zh_TW_46json_a86b7ad4",
      load: () => Promise.resolve(locale_zh_TW_46json_a86b7ad4),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/a897387c" /* webpackChunkName: "config_i18n_46config_46ts_a897387c" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/usr/src/app/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      files: [
        {
          path: "/usr/src/app/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      files: [
        {
          path: "/usr/src/app/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      name: "Русский",
      files: [
        {
          path: "/usr/src/app/i18n/locales/ru.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh-CN",
      name: "简体中文",
      files: [
        {
          path: "/usr/src/app/i18n/locales/zh_CN.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zh_TW",
      name: "繁體中文",
      files: [
        {
          path: "/usr/src/app/i18n/locales/zh_TW.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: true,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/usr/src/app/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    files: [
      {
        path: "/usr/src/app/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    files: [
      {
        path: "/usr/src/app/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    name: "Русский",
    files: [
      {
        path: "/usr/src/app/i18n/locales/ru.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh-CN",
    name: "简体中文",
    files: [
      {
        path: "/usr/src/app/i18n/locales/zh_CN.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zh_TW",
    name: "繁體中文",
    files: [
      {
        path: "/usr/src/app/i18n/locales/zh_TW.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/